import classNames from 'classnames';
import * as React from 'react';

import { ResponsivePicture } from '../../ReactComponents/ResponsivePicture/ResponsivePicture';
import { TextColor } from '../TextColor.csharp';
import { CategoryBlockViewModel } from './CategoryBlockViewModel.csharp';

export const CategoryBlock = ({ model }: { model: CategoryBlockViewModel }) => {
    return (
        <div className="CategoryBlock">
            <a className="CategoryBlock__Link" href={model.link} target={model.openInNewTab ? '_blank' : '_self'} rel="noreferrer">
                <div className="CategoryBlock__ImageWrapper">
                    <div className="CategoryBlock__Image">
                        {model.image && <ResponsivePicture profile={model.pictureProfile} model={model.image} isLazyLoaded />}
                        {model.imageText && (
                            <span className={classNames('CategoryBlock__ImageText', `CategoryBlock__ImageText--${TextColor[model.textColor]}`)}>
                                {model.imageText}
                            </span>
                        )}
                    </div>
                </div>
                <span className="CategoryBlock__Heading">{model.heading}</span>
                {model.promotionText && <span className="CategoryBlock__PromotionText">{model.promotionText}</span>}
            </a>
            {model.additionalLinks && (
                <>
                    <div className="CategoryBlock__Links CategoryBlock__Links--Desktop">
                        {model.additionalLinks.map((additionalLink, i) => (
                            <a key={i} className="CategoryBlock__AdditionalLink" href={additionalLink.href}>
                                {additionalLink.text}
                            </a>
                        ))}
                    </div>
                    <div className="CategoryBlock__Links CategoryBlock__Links--Mobile">
                        <a className="CategoryBlock__AdditionalLink" href={model.link} target="_blank" rel="noreferrer">
                            {model.additionalLinks.map((x) => x.text).join(', ')}
                        </a>
                    </div>
                </>
            )}
        </div>
    );
};
